import { useEffect } from 'react';

export const useSyncSelectedService = ({
    selectedInfo,
    selectedServiceId,
    onSelectServiceHandler,
}) => {
    useEffect(() => {
        if (selectedInfo?.services && selectedInfo.services !== selectedServiceId) {
            onSelectServiceHandler(selectedInfo.services);
        }
    }, [ selectedInfo?.services, selectedServiceId, onSelectServiceHandler ]);
};
